// extracted by mini-css-extract-plugin
export var container = "_b1-1";
export var cornerButtonContainer = "_b1-5";
export var disabled = "_b1-2";
export var fileContainer = "_b1-4";
export var hiddenInput = "_b1-3";
export var widthContainer = "_b1-0";